import styled from 'styled-components';

export const BeneficiariesListContainer = styled.div`
  margin-top: 3%;
`;

export const BeneficiariesListFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3%;
`;

export const BeneficiariesListRightBottom = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CreateBeneficiariesPercentageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CreateBeneficiariesPercentage = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CreateBeneficiariesPercentageInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #f3f4f8;
  border-radius: 20px;
`;

export const CreateBeneficiariesPercentageInputs = styled.div`
  display: flex;
  margin-bottom: 5%;
  justify-content: space-between;
`;
